import { Link } from 'react-router-dom';
import { Category } from '@/lib/types';
import { cn } from '@/lib/utils';

interface CategoryBadgeProps {
  category: Category;
  size?: 'sm' | 'md';
  linked?: boolean;
  className?: string;
}

export function CategoryBadge({ 
  category, 
  size = 'md', 
  linked = true,
  className 
}: CategoryBadgeProps) {
  const styles = {
    backgroundColor: `${category.color}20`,
    color: category.color || '#10b981',
    borderColor: `${category.color}40`,
  };

  const classes = cn(
    'category-badge inline-flex items-center border transition-colors',
    size === 'sm' ? 'px-2 py-0.5 text-[10px]' : 'px-3 py-1 text-xs',
    'hover:opacity-80',
    className
  );

  if (linked) {
    return (
      <Link to={`/category/${category.slug}`} className={classes} style={styles}>
        {category.name}
      </Link>
    );
  }

  return (
    <span className={classes} style={styles}>
      {category.name}
    </span>
  );
}
